import { Text } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import {
  BLOCK_HEIGHT,
  HOURS_LIST,
  SMALL_COLUMN_WIDTH,
} from "src/views/schedule/constants";

const CalendarColumnSmall = styled.div`
  width: ${SMALL_COLUMN_WIDTH}px;
`;

const TimeBlock = styled.div`
  height: ${BLOCK_HEIGHT}px;
  position: relative;
`;

const TimeBlockInner = styled.div`
  position: absolute;
  display: flex;
  height: ${BLOCK_HEIGHT}px;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  transform: translateY(-50%);
`;

const TimeText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 16px;
  gap: 8px;
`;

interface ShiftTimeLineColumnProps {
  date: Date;
}

export const ShiftTimeLineColumn: React.FC<ShiftTimeLineColumnProps> = ({
  date,
}) => (
  <CalendarColumnSmall>
    {HOURS_LIST.map((hour) => (
      <TimeBlock key={hour}>
        <TimeBlockInner>
          <TimeText>
            {hour === "12am" && (
              <Text mods="bold">
                {date.toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                })}
              </Text>
            )}
            <Text mods="subtle">{hour}</Text>
            {hour === "12am" && <Text>&nbsp;</Text>}
          </TimeText>
        </TimeBlockInner>
      </TimeBlock>
    ))}
  </CalendarColumnSmall>
);
